import React from 'react'

const CalenderGreenSvg = ({ width }) => {
  return (
    <svg
      id='calendar-svgrepo-com_5_'
      data-name='calendar-svgrepo-com (5)'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 17.466 17.685'
    >
      <path
        id='Path_3182'
        data-name='Path 3182'
        d='M7.032,2.4a.655.655,0,1,0-1.31,0V3.784a3.988,3.988,0,0,0-2.688.954,3.988,3.988,0,0,0-.954,2.688H19.407a3.988,3.988,0,0,0-.954-2.688,3.988,3.988,0,0,0-2.688-.954V2.4a.655.655,0,1,0-1.31,0V3.726c-.581-.011-1.232-.011-1.965-.011H9c-.733,0-1.384,0-1.965.011Z'
        transform='translate(-2.01 -1.75)'
        fill='#b5ccc2'
      />
      <path
        id='Path_3183'
        data-name='Path 3183'
        d='M2,11.715c0-.733,0-1.384.011-1.965H19.455c.011.581.011,1.232.011,1.965v1.747c0,3.293,0,4.94-1.023,5.963s-2.67,1.023-5.963,1.023H8.987c-3.294,0-4.94,0-5.963-1.023S2,16.755,2,13.462Zm13.1,1.747a.873.873,0,1,0-.873-.873A.873.873,0,0,0,15.1,13.462Zm0,3.493a.873.873,0,1,0-.873-.873A.873.873,0,0,0,15.1,16.955Zm-3.493-4.367a.873.873,0,1,1-.873-.873A.873.873,0,0,1,11.607,12.588Zm0,3.493a.873.873,0,1,1-.873-.873A.873.873,0,0,1,11.607,16.082Zm-5.24-2.62a.873.873,0,1,0-.873-.873A.873.873,0,0,0,6.367,13.462Zm0,3.493a.873.873,0,1,0-.873-.873A.873.873,0,0,0,6.367,16.955Z'
        transform='translate(-2 -2.763)'
        fill='#b5ccc2'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default CalenderGreenSvg
